<template>
  <div class="header" id="form-header">
    <h2>{{ getPetitionCount }}</h2>

    <DisplayProgressBar
      :percentage="60"
    ></DisplayProgressBar>

    <p>{{ title }}</p>
  </div>
</template>

<script>
import firebase from "firebase";
import DisplayProgressBar from '../display-progress-numbers/DisplayProgressBar.vue';

export default {
  name: "FormHeader",
  components: {
    DisplayProgressBar,
  },
  data() {
    return {
      petitionCount: 0,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    datalayerName: {
      type: String,
    },
  },
  async created() {
    firebase
      .firestore()
      .collection("campaigns")
      .doc(this.datalayerName)
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.data();
          if (!!data) {
            this.petitionCount = data.count;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  },
  computed: {
    getPetitionCount() {
      return this.petitionCount.toLocaleString('en-AU');
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.header h2 {
  font-family: "WWF",sans-serif;
  font-size: 80px;
}

.header p {
  width: 80%;
  text-align: center;
  font-size: 20px;
  line-height: 150%;
}

@media screen and (max-width: 800px) {
  .progress-bar {
    width: 80%;
  }

  .header p {
    width: 100%;
  }
}
/* END */
</style>



// WEBPACK FOOTER //
// Header.vue?12b69f4e